(() => {
  const instances = new WeakMap();

  const parseEndTime = (value) => {
    if (!value) return null;
    let parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) return parsed;

    const normalized = value.replace(' ', 'T');
    parsed = new Date(normalized);
    if (!Number.isNaN(parsed.getTime())) return parsed;

    const match = normalized.match(
      /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/
    );
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    const hour = Number(match[4]);
    const minute = Number(match[5]);
    const second = Number(match[6]);
    const tz = match[7];

    if (!tz || tz === 'Z') {
      return new Date(Date.UTC(year, month, day, hour, minute, second));
    }

    const tzMatch = tz.match(/^([+-])(\d{2}):?(\d{2})$/);
    if (!tzMatch) return null;
    const sign = tzMatch[1] === '-' ? -1 : 1;
    const tzHours = Number(tzMatch[2]);
    const tzMinutes = Number(tzMatch[3]);
    const offsetMinutes = sign * (tzHours * 60 + tzMinutes);
    const utcTime = Date.UTC(year, month, day, hour, minute, second) - offsetMinutes * 60000;
    return new Date(utcTime);
  };

  const pad = (value) => String(value).padStart(2, '0');

  const setCopiedState = (button) => {
    const copyLabel = button.getAttribute('data-copy-label') || 'Copy';
    const copiedLabel = button.getAttribute('data-copied-label') || 'Copied';
    button.textContent = copiedLabel;
    setTimeout(() => {
      button.textContent = copyLabel;
    }, 1500);
  };

  const handleCopy = async (event) => {
    event.preventDefault();
    const button = event.currentTarget;
    const text = button.getAttribute('data-copy-text') || '';
    if (!text) return;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        setCopiedState(button);
        return;
      }
    } catch (error) {
      // fallback below
    }

    const temp = document.createElement('textarea');
    temp.value = text;
    temp.setAttribute('readonly', '');
    temp.style.position = 'absolute';
    temp.style.left = '-9999px';
    document.body.appendChild(temp);
    temp.select();
    const copied = document.execCommand('copy');
    temp.remove();
    if (copied) {
      setCopiedState(button);
    }
  };

  const initElement = (element) => {
    if (instances.has(element)) return;

    const endTime = (element.getAttribute('data-end-time') || '').trim();
    const dEl = element.querySelector('.d');
    const hEl = element.querySelector('.h');
    const mEl = element.querySelector('.m');
    const sEl = element.querySelector('.s');

    const copyBtn = element.querySelector('[data-copy]');
    if (copyBtn && !copyBtn.dataset.copyBound) {
      copyBtn.addEventListener('click', handleCopy);
      copyBtn.dataset.copyBound = 'true';
    }

    if (!endTime || !dEl || !hEl || !mEl || !sEl) return;

    const endDate = parseEndTime(endTime);
    if (!endDate) return;

    const updateTimer = () => {
      const diff = Math.max(0, endDate.getTime() - Date.now());
      if (diff <= 0) {
        element.style.display = 'none';
        const instance = instances.get(element);
        if (instance?.interval) {
          clearInterval(instance.interval);
        }
        return;
      }

      let secs = Math.floor(diff / 1000);
      const days = Math.floor(secs / 86400);
      secs -= days * 86400;
      const hours = Math.floor(secs / 3600);
      secs -= hours * 3600;
      const minutes = Math.floor(secs / 60);
      secs -= minutes * 60;
      const seconds = secs;

      dEl.textContent = pad(days);
      hEl.textContent = pad(hours);
      mEl.textContent = pad(minutes);
      sEl.textContent = pad(seconds);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    instances.set(element, { interval });
  };

  const init = (scope = document) => {
    const elements = scope.querySelectorAll('[data-countdown-discount]');
    elements.forEach((element) => initElement(element));
  };

  const cleanup = (scope) => {
    const elements = scope.querySelectorAll('[data-countdown-discount]');
    elements.forEach((element) => {
      const instance = instances.get(element);
      if (instance?.interval) {
        clearInterval(instance.interval);
      }
      instances.delete(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    cleanup(event.target);
  });
})();
